import React, { type SyntheticEvent, useRef, useState } from 'react'
import {
  Autocomplete,
  Box,
  Checkbox, CircularProgress,
  FormControlLabel,
  FormGroup,
  TextField
} from '@mui/material'
import { ReactComponent as PersonIcon } from 'icons/person.svg'
import { CorporateFare } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { searchWithQueryAndParams } from 'services'
import { useSessionContext } from '../../../session'
export interface SearchOption {
  title: string
  id: string
  type: EntityType
  refId: string
}
export enum EntityType {
  PERSON = 'person',
  ORGANIZATION = 'org'
}

export const EntityAutoComplete: React.FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const [options, setOptions] = useState<SearchOption[]>([])
  const [searchOrgs, setSearchOrgs] = useState(true)
  const [searchPositions, setSearchPositions] = useState(false)
  const [inputValue, setInputValue] = useState<string>('')
  const timeoutRef = useRef<NodeJS.Timeout | undefined>()
  const { openNewTab } = useSessionContext()

  const getData = (searchTerm: string): void => {
    searchTerm = searchTerm !== '' ? searchTerm.trim() : ''
    setLoading(true)
    searchWithQueryAndParams(searchTerm, searchOrgs, false, searchPositions).then(value => {
      setOptions((value != null) ? value : [])
      setLoading(false)
    }).catch(reason => { console.log(reason) })
  }

  const onInputChange = (
    event: SyntheticEvent<Element, Event>,
    value: string,
    reason: string
  ): void => {
    setInputValue(reason === 'input' ? value : '')

    if (reason === 'input' && (value.length >= 3 || !isNaN(Number(value)))) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => { getData(value) }, 500)
    } else {
      setOptions([])
    }
  }

  return (
        <Box sx ={{ ml: 7 }}>
            <FormGroup row={true}>
                <FormControlLabel control={<Checkbox checked={searchOrgs} onChange={(e, checked) => { setSearchOrgs(checked) }}/>} label="Organizations"/>
                <FormControlLabel disabled={true} control={<Checkbox checked={searchPositions} onChange={(e, checked) => { setSearchPositions(checked) }}/>} label="Positions"/>
            </FormGroup>
            <Box sx={{ display: 'flex', gap: 2, width: '70vw' }}>
            <Autocomplete
                id="combo-box-demo"
                options={options}
                onInputChange={onInputChange}
                inputValue={inputValue}
                getOptionLabel={(option) => option.title}
                style={{ width: '90%' }}
                filterOptions={options1 => options1}
                isOptionEqualToValue={(option, value) =>
                  option.id.toString() === value?.id.toString()
                }
                onChange={(event, option: SearchOption | null) => {
                  if ((option?.refId) != null) {
                    if (option.type === EntityType.PERSON) {
                      navigate('/addPerson', {
                        state: { id: option.refId }
                      })
                    }
                    if (option.type === EntityType.ORGANIZATION) {
                      openNewTab(`/editOrganization/${option.refId}`)
                    }
                  }
                }}
                renderInput={(params) => <TextField {...params} label="ex:Defense Department.." variant="outlined"/>}
                renderOption={(props, option) => (
                    <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props} key={option.id}>
                        {option.type === 'person' && <PersonIcon width="20px"/>}
                        {option.type === 'org' && <CorporateFare/>}

                        {option.title}
                    </Box>
                )}
            />
                {loading && <CircularProgress sx={{ alignSelf: 'center' }}/>}
            </Box>
        </Box>
  )
}
